import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  input: {
    minWidth: 400,
    maxWidth: 600,
  },
}));

function AmountAutoComplete({
  availableCharges,
  selectedCharge,
  setSelectedCharge,
  autoFocus,
  disabled,
}) {
  const classes = useStyles();

  function handleChange(_, value) {
    setSelectedCharge(value);
  }

  return (
    <Autocomplete
      id="po-search-status-autocomplete"
      data-test='po-search-status-autocomplete'
      disabled={disabled}
      options={availableCharges}
      getOptionLabel={(option) => option.formattedName}
      value={selectedCharge}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Available Charge Codes"
          variant="outlined"
          autoFocus={autoFocus}
          className={classes.input}
        />
      )}
    />
  );
}

AmountAutoComplete.propTypes = {
  autoFocus: PropTypes.bool,
  availableCharges: PropTypes.arrayOf(PropTypes.shape({
    purchaseOrderChargeTypeId: PropTypes.string,
    purchaseOrderChargeTypeName: PropTypes.string,
    isCalculated: PropTypes.bool,
    isExternalEditable: PropTypes.bool,
    isInternalEditable: PropTypes.bool,
    categoryId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
  })),
  selectedCharge: PropTypes.shape({
    poNumber: PropTypes.number,
    purchaseOrderChargeTypeId: PropTypes.string,
    purchaseOrderChargeTypeName: PropTypes.string,
    amount: PropTypes.number,
    isCalculated: PropTypes.bool,
    isExternalEditable: PropTypes.bool,
    isInternalEditable: PropTypes.bool,
    categoryId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
  }),
  setSelectedCharge: PropTypes.func,
  disabled: PropTypes.bool,
};

export default AmountAutoComplete;
